<div class="error-container">
  <div class="card">
    <div class="card-body">
      <h2>Access Denied</h2>
      <p>You do not have permission to access this resource.</p>
    </div>
  </div>
  
  </div>